import axios from 'axios'

axios.defaults.baseURL = process.env.API_URL
axios.defaults.withCredentials = true
axios.defaults.xsrfCookieName = 'X-CSRF-Token'
axios.defaults.xsrfHeaderName = 'X-CSRF-Token'
axios.defaults.headers.common['X-Front-End-Build-Number'] = process.env.BUILD_NUMBER

axios.interceptors.response.use(
	(response) => {
		if (response.headers['x-prospectix-jwt'])
			sessionStorage.setItem('prospectix_jwt', response.headers['x-prospectix-jwt'])
		if (response.headers['x-highest-front-end-build-number'])
			sessionStorage.setItem(
				'highest_front_end_build_number',
				response.headers['x-highest-front-end-build-number'],
			)
		if (response.headers['x-deployment-id'])
			sessionStorage.setItem('deployment_id', response.headers['x-deployment-id'])
		return response
	},
	(error) => Promise.reject(error),
)

axios.interceptors.request.use(
	(config) => {
		if (sessionStorage.getItem('prospectix_jwt'))
			config.headers['X-Prospectix-JWT'] = sessionStorage.getItem('prospectix_jwt')
		return config
	},
	(error) => Promise.reject(error),
)
